import { gql } from '@apollo/client';

export const RecentDashboardVisitFieldsFragment = gql`
  fragment RecentDashboardVisitFields on RecentDashboardVisit {
    dashboardBaseId
    display
    description
    createdAt
    visitedAt
    isFavorite
    isDeleted
    lastEditor {
      id
      name
      picture
    }
    creator {
      id
      name
      picture
    }
  }
`;

export const RecentAnalysisVisitFieldsFragment = gql`
  fragment RecentAnalysisVisitFields on RecentAnalysisVisit {
    analysisId
    queryType
    display
    description
    createdAt
    visitedAt
    status
    isFavorite
    lastEditor {
      id
      name
      picture
    }
    creator {
      id
      name
      picture
    }
  }
`;
